import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=b4cabc58&scoped=true"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=b4cabc58&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cabc58",
  null
  
)

export default component.exports